import { useEffect } from 'react';

import { Keys, getSystem } from '@/system';

import usePageState from './usePageState';

const system = getSystem();

/**
 * attaches back remote key press listener to app
 * @param router
 */
export const useBack = (handleBack?: () => void) => {
  const { back } = usePageState();

  const handler = (e: KeyboardEvent) => {
    const key = system.key(e);
    if (key === Keys.BACK) {
      e.preventDefault();
      handleBack && handleBack();
      back(); //router.back()
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, []);
};
